import React from 'react';
import { Ruler, Weight, User } from 'lucide-react';

const UserInfoBox = ({ userInfo, onChange }) => {
  // Handle height change
  const handleHeightChange = (event) => {
    const height = parseInt(event.target.value, 10);
    onChange({ height });
  };
  
  // Handle weight change
  const handleWeightChange = (event) => {
    const weight = parseInt(event.target.value, 10);
    onChange({ weight });
  };
  
  // Handle build change
  const handleBuildChange = (event) => {
    const build = event.target.value;
    onChange({ build });
  };

  const renderControlItem = (icon, label, control) => {
    return React.createElement('div', {
      className: 'control-item animate-fade-in',
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '24px'
      }
    },
      React.createElement('div', {
        className: 'control-icon',
        style: {
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          backgroundColor: 'var(--card-bg)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--secondary)',
          transition: 'all var(--transition-speed) ease',
        }
      }, icon),
      React.createElement('div', {
        style: {
          flex: 1
        }
      },
        React.createElement('label', {
          style: {
            display: 'block',
            marginBottom: '8px',
            fontWeight: 600,
            fontSize: '0.9rem'
          }
        }, label),
        control
      )
    );
  };

  return React.createElement('div', { className: 'card' },
    React.createElement('h3', { className: 'subtitle' }, 'Your Measurements'),
    React.createElement('p', {
      style: {
        marginBottom: '24px'
      }
    }, 'Help us find the perfect size for you'),
    
    renderControlItem(
      React.createElement(Ruler, { size: 20 }),
      'Height (cm)',
      React.createElement('input', {
        type: 'number',
        value: userInfo.height,
        onChange: handleHeightChange,
        min: 100,
        max: 220,
        className: 'input',
        style: { padding: '8px 12px' }
      })
    ),
    
    renderControlItem(
      React.createElement(Weight, { size: 20 }),
      'Weight (kg)',
      React.createElement('input', {
        type: 'number',
        value: userInfo.weight,
        onChange: handleWeightChange,
        min: 30,
        max: 200,
        className: 'input',
        style: { padding: '8px 12px' }
      })
    ),
    
    renderControlItem(
      React.createElement(User, { size: 20 }),
      'Body Build',
      React.createElement('select', {
        value: userInfo.build,
        onChange: handleBuildChange,
        className: 'input',
        style: { padding: '8px 12px', appearance: 'none' }
      },
        React.createElement('option', { value: 'lean' }, 'Lean'),
        React.createElement('option', { value: 'regular' }, 'Regular'),
        React.createElement('option', { value: 'athletic' }, 'Athletic'),
        React.createElement('option', { value: 'big' }, 'Big')
      )
    ),
    
    
  );
};

export default UserInfoBox;